<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah Izin Usaha Perusahaan</h4>
          <button type="button" class="btn btn-sm" v-on:click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="perizinanData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column100"><strong>Bidang</strong></div>
          </div>
          <div
            class="horizontal"
            v-for="(item, index) in perizinan"
            :key="index"
          >
            <div class="column5">
              <input
                class="modal-input-checkbox"
                type="checkbox"
                :id="index"
                :value="item.id"
                v-model="perizinan[index]['checked']"
              />
            </div>
            <div class="column100">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            v-on:click="closeModal()"
          >
            Selesai
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['modelName', 'mutationName', 'storeName', 'modalName'],
  data() {
    return {
      perizinan: [],
    }
  },
  computed: {
    perizinanData: async function() {
      let getLegal = await this.$getLegal()

      getLegal = await getLegal.filter(i => i.type == 3)
      const defaultPerizinan = await this.$store.state[this.storeName][
        this.modelName
      ]

      let reducePerizinan = await getLegal.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )
      let reduceDefault =
        (await defaultPerizinan) &&
        defaultPerizinan.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reducePerizinan, ...reduceDefault }

      let newPerizinan = await Object.values(combine)
      this.perizinan = newPerizinan.sort((a, b) => this.$sortAsc(a, b))
    },
    filteredPerizinan: function() {
      const filtered =
        this.perizinan &&
        this.perizinan.filter(i => i.checked && i.checked == true)
      return filtered
    },
  },
  methods: {
    async closeModal() {
      const filterPerizinan = this.perizinan
      await this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: false,
      })
      await this.$store.commit(this.mutationName, {
        name: this.modelName,
        value: filterPerizinan,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  background-color: green;
}

.modal-content {
  width: 90vw;
  position: absolute;
  transform: translateX(-30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
